

export function getSecurityTypes(props) {
  if(props.value === "BONDS"){
    return [
      { name: 'Bonds', value: 'BONDS' },
      { name: 'Commercial Paper', value: 'COMMERCIAL_PAPER' },
      { name: 'Long Term Negotiable Certificates of Time Deposit', value: 'LTNCTD' },
      { name: 'Amortizing Bonds', value: 'AMORTIZING_BONDS' }
    ]
  }
  return [
    { name: 'Bank Bonds', value: 'BONDS_BANK'},
    { name: 'Corporate Bonds: Registered Securities', value: 'BONDS_CORPORATE'},
    { name: 'Corporate Bonds: Shelf - Registered Securities', value: 'BONDS_CORPORATE_SHELF'},
    { name: 'Commercial Paper', value: 'COMMERCIAL_PAPER' },
    { name: 'Fixed Rate Notes', value: 'LTNCTD' },
    { name: 'Amortizing Bonds', value: 'AMORTIZING_BONDS' }
  ]
}

export function getSecurityClass() {
    return [
     { name: 'Scripless', value: 'SCRIPLESS' },
     { name: 'Digital', value: 'DIGITAL' }
    ]
  }
export function getSecurityForm() {
  return [
    { name: 'Uncertificated', value: 'UNCERTIFICATED' },
    { name: 'Immobilized', value: 'IMMOBILIZED' },
    { name: '100% Scripless', value: 'SCRIPLESS' },
  ]
}

export function getCouponTypes() {
  return [
    { name: 'Discount', value: 'DISCOUNT' },
    { name: 'Fixed', value: 'FIXED' },
    { name: 'Floating', value: 'FLOATING' },
    { name: 'Stepped', value: 'STEPPED' },
  ]
}

export function getTransferOfSecurityRestrictions() {
  return [
    { name: 'No restrictions', value: 'NO_RESTRICTIONS' },
    { name: 'Restricted to Non-Qualified Investors', value: 'NON_QUALIFIED_INVESTORS' },
    { name: 'Restricted to Bank\'s Subsidiaries and Affiliates', value: 'BANKS_SUBS_AND_AFFIL' },
  ]
}

export function getCouponFrequencies() {
  return [
    { name: 'Zero-Coupon', value: 'ZERO' },
    { name: 'Monthly', value: 'MONTHLY' },
    { name: 'Quarterly', value: 'QUARTERLY' },
    { name: 'Semi-Annual', value: 'SEMI-ANNUAL' },
    { name: 'Annual', value: 'ANNUAL' }
  ]
}

export function getMannerOfDistribution() {
  return [
    { name: 'Public', value: 'PUBLIC' },
    { name: 'Private', value: 'PRIVATE' },
    { name: 'Unlisted', value: 'UNLISTED' }
  ]
}

export function getWTPEIRemittanceConvention() {
  return [
    { name: 'Not Applicable', value: 'NA'},
    { name: 'On Settlement Date of trade only', value: 'ON_SETT_DATE' },
    { name: 'Up to next Business day after settlement date of a trade', value: 'NEXT_BUSINESS_DAY' },
  ]
}

export function getDayCountConvenntion() {
  return [
    { name: '30E/360 ISMA', value: '30E/360 ISMA' },
    { name: 'Actual/360', value: 'ACTUAL/360' },
    { name: 'Actual/365', value: 'ACTUAL/365' },
    { name: 'Actual/Actual', value: 'ACTUAL/ACTUAL' }
  ]
}

export function getPrincipalRepaymentSched() {
  return [
    { name: 'Balloon', value: 'BALLOON' },
    { name: 'Amortized', value: 'AMORTIZED' }
  ]
}

export function getYearBasis() {
  return [
    { name: '360', value: '360' },
    { name: '365', value: '365' }
  ]
}

export function getNumberOfSecurity() {
  return [
    { name: 'Single', value: 'SINGLE' },
    { name: 'Multiple', value: 'MULTIPLE' }
  ]
}

export function getCurrency() {
  return [
    { name: 'US Dollar', value: 'USD' },
    { name: 'Canadian Dollar', value: 'CAD' },
    { name: 'Euro', value: 'EUR' },
    { name: 'United Arab Emirates Dirham', value: 'AED' },
    { name: 'Afghan Afghani', value: 'AFN' },
    { name: 'Albanian Lek', value: 'ALL' },
    { name: 'Armenian Dram', value: 'AMD' },
    { name: 'Argentine Peso', value: 'ARS' },
    { name: 'Australian Dollar', value: 'AUD' },
    { name: 'Azerbaijani Manat', value: 'AZN' },
    { name: 'Bosnia-Herzegovina Convertible Mark', value: 'BAM' },
    { name: 'Bangladeshi Taka', value: 'BDT' },
    { name: 'Bulgarian Lev', value: 'BGN' },
    { name: 'Bahraini Dinar', value: 'BHD' },
    { name: 'Burundian Franc', value: 'BIF' },
    { name: 'Brunei Dollar', value: 'BND' },
    { name: 'Bolivian Boliviano', value: 'BOB' },
    { name: 'Brazilian Real', value: 'BRL' },
    { name: 'Botswanan Pula', value: 'BWP' },
    { name: 'Belarusian Ruble', value: 'BYN' },
    { name: 'Belize Dollar', value: 'BZD' },
    { name: 'Congolese Franc', value: 'CDF' },
    { name: 'Swiss Franc', value: 'CHF' },
    { name: 'Chilean Peso', value: 'CLP' },
    { name: 'Chinese Yuan', value: 'CNY' },
    { name: 'Colombian Peso', value: 'COP' },
    { name: 'Costa Rican Colón', value: 'CRC' },
    { name: 'Cape Verdean Escudo', value: 'CVE' },
    { name: 'Czech Republic Koruna', value: 'CZK' },
    { name: 'Djiboutian Franc', value: 'DJF' },
    { name: 'Danish Krone', value: 'DKK' },
    { name: 'Dominican Peso', value: 'DOP' },
    { name: 'Algerian Dinar', value: 'DZD' },
    { name: 'Estonian Kroon', value: 'EEK' },
    { name: 'Egyptian Pound', value: 'EGP' },
    { name: 'Eritrean Nakfa', value: 'ERN' },
    { name: 'Ethiopian Birr', value: 'ETB' },
    { name: 'British Pound Sterling', value: 'GBP' },
    { name: 'Georgian Lari', value: 'GEL' },
    { name: 'Ghanaian Cedi', value: 'GHS' },
    { name: 'Guinean Franc', value: 'GNF' },
    { name: 'Guatemalan Quetzal', value: 'GTQ' },
    { name: 'Hong Kong Dollar', value: 'HKD' },
    { name: 'Honduran Lempira', value: 'HNL' },
    { name: 'Croatian Kuna', value: 'HRK' },
    { name: 'Hungarian Forint', value: 'HUF' },
    { name: 'Indonesian Rupiah', value: 'IDR' },
    { name: 'Israeli New Sheqel', value: 'ILS' },
    { name: 'Indian Rupee', value: 'INR' },
    { name: 'Iraqi Dinar', value: 'IQD' },
    { name: 'Iranian Rial', value: 'IRR' },
    { name: 'Icelandic Króna', value: 'ISK' },
    { name: 'Jamaican Dollar', value: 'JMD' },
    { name: 'Jordanian Dinar', value: 'JOD' },
    { name: 'Japanese Yen', value: 'JPY' },
    { name: 'Kenyan Shilling', value: 'KES' },
    { name: 'Cambodian Riel', value: 'KHR' },
    { name: 'Comorian Franc', value: 'KMF' },
    { name: 'South Korean Won', value: 'KRW' },
    { name: 'Kuwaiti Dinar', value: 'KWD' },
    { name: 'Kazakhstani Tenge', value: 'KZT' },
    { name: 'Lebanese Pound', value: 'LBP' },
    { name: 'Sri Lankan Rupee', value: 'LKR' },
    { name: 'Lithuanian Litas', value: 'LTL' },
    { name: 'Latvian Lats', value: 'LVL' },
    { name: 'Libyan Dinar', value: 'LYD' },
    { name: 'Moroccan Dirham', value: 'MAD' },
    { name: 'Moldovan Leu', value: 'MDL' },
    { name: 'Malagasy Ariary', value: 'MGA' },
    { name: 'Macedonian Denar', value: 'MKD' },
    { name: 'Myanma Kyat', value: 'MMK' },
    { name: 'Macanese Pataca', value: 'MOP' },
    { name: 'Mauritian Rupee', value: 'MUR' },
    { name: 'Mexican Peso', value: 'MXN' },
    { name: 'Malaysian Ringgit', value: 'MYR' },
    { name: 'Mozambican Metical', value: 'MZN' },
    { name: 'Namibian Dollar', value: 'NAD' },
    { name: 'Nigerian Naira', value: 'NGN' },
    { name: 'Nicaraguan Córdoba', value: 'NIO' },
    { name: 'Norwegian Krone', value: 'NOK' },
    { name: 'Nepalese Rupee', value: 'NPR' },
    { name: 'New Zealand Dollar', value: 'NZD' },
    { name: 'Omani Rial', value: 'OMR' },
    { name: 'Panamanian Balboa', value: 'PAB' },
    { name: 'Peruvian Nuevo Sol', value: 'PEN' },
    { name: 'Philippine Peso', value: 'PHP' },
    { name: 'Pakistani Rupee', value: 'PKR' },
    { name: 'Polish Zloty', value: 'PLN' },
    { name: 'Paraguayan Guarani', value: 'PYG' },
    { name: 'Qatari Rial', value: 'QAR' },
    { name: 'Romanian Leu', value: 'RON' },
    { name: 'Serbian Dinar', value: 'RSD' },
    { name: 'Russian Ruble', value: 'RUB' },
    { name: 'Rwandan Franc', value: 'RWF' },
    { name: 'Saudi Riyal', value: 'SAR' },
    { name: 'Sudanese Pound', value: 'SDG' },
    { name: 'Swedish Krona', value: 'SEK' },
    { name: 'Singapore Dollar', value: 'SGD' },
    { name: 'Somali Shilling', value: 'SOS' },
    { name: 'Syrian Pound', value: 'SYP' },
    { name: 'Thai Baht', value: 'THB' },
    { name: 'Tunisian Dinar', value: 'TND' },
    { name: 'Tongan Paʻanga', value: 'TOP' },
    { name: 'Turkish Lira', value: 'TRY' },
    { name: 'Trinidad and Tobago Dollar', value: 'TTD' },
    { name: 'New Taiwan Dollar', value: 'TWD' },
    { name: 'Tanzanian Shilling', value: 'TZS' },
    { name: 'Ukrainian Hryvnia', value: 'UAH' },
    { name: 'Ugandan Shilling', value: 'UGX' },
    { name: 'Uruguayan Peso', value: 'UYU' },
    { name: 'Uzbekistan Som', value: 'UZS' },
    { name: 'Venezuelan Bolívar', value: 'VEF' },
    { name: 'Vietnamese Dong', value: 'VND' },
    { name: 'CFA Franc BEAC', value: 'XAF' },
    { name: 'CFA Franc BCEAO', value: 'XOF' },
    { name: 'Yemeni Rial', value: 'YER' },
    { name: 'South African Rand', value: 'ZAR' },
    { name: 'Zambian Kwacha', value: 'ZMK' },
    { name: 'Zimbabwean Dollar', value: 'ZWL' }
  ]
}






